exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scores-container[data-v-bec3a89e]{width:100%}", ""]);

// exports
